<section class="page">
  <header class="page-header">
    <h2>Voir les nomenclatures</h2>
    <button type="button" class="btn-refresh" (click)="refresh()">Rafraîchir</button>
  </header>

  <div class="toolbar">
    <label for="filter">Filtre</label>
    <input
      id="filter"
      type="text"
      [(ngModel)]="filter"
      (ngModelChange)="onFilterChange()"
      placeholder="Numéro, nom, date"
    />
  </div>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (loading) {
    <p>Chargement...</p>
  } @else if (error) {
    <p class="error">{{ error }}</p>
  } @else {
    <p class="meta">{{ filteredNomenclatures.length }} résultat(s)</p>

    @if (filteredNomenclatures.length === 0) {
      <p>Aucune nomenclature trouvée pour ce filtre.</p>
    }

    <div class="table-wrap panel">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Numéro</th>
            <th>Nom</th>
            <th>Prix HT</th>
            <th>Date de création</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (nomenclature of paginatedNomenclatures; track nomenclature.id) {
            <tr>
              <td>{{ nomenclature.id }}</td>
              <td>{{ nomenclature.numero_nomenclature }}</td>
              <td>{{ nomenclature.nom }}</td>
              <td>{{ nomenclaturePrixHt[nomenclature.id] | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td>
              <td>{{ nomenclature.date_creation | date:'dd/MM/yyyy' }}</td>
              <td class="actions-cell">
                <button
                  type="button"
                  class="edit"
                  (click)="editNomenclature(nomenclature)"
                >
                  Editer
                </button>
                <button
                  type="button"
                  class="danger"
                  [disabled]="loading || deletingId === nomenclature.id"
                  (click)="deleteNomenclature(nomenclature)"
                >
                  {{ deletingId === nomenclature.id ? 'Suppression...' : 'Supprimer' }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 1) {
      <div class="pagination">
        <button type="button" [disabled]="page === 1" (click)="previousPage()">Précédent</button>
        <span>Page {{ page }} / {{ totalPages }}</span>
        <button type="button" [disabled]="page === totalPages" (click)="nextPage()">Suivant</button>
      </div>
    }
  }
</section>
